import * as React from 'react';
import { InjectedIntlProps, injectIntl } from 'react-intl';
import { connect } from 'react-redux';

import BooksStaffMenu from '../../../../components/books/courses/BooksStaffMenu';

import * as IBooks from '../../../../interfaces/merchants/resources/books';

interface StaffProps {
  random: boolean;
  staffs: IBooks.RealStaff[];
  postable: boolean;
  onClick: (staff: IBooks.Staff) => void;
}

type Props = StaffProps & InjectedIntlProps;

class InputBookingTargetStaffSelector extends React.Component<Props> {
  constructor(props: Props) {
    super(props);
    this.handleChangeStaff = this.handleChangeStaff.bind(this);
  }

  public handleChangeStaff(e: React.MouseEvent<HTMLButtonElement>) {
    const { staffs, onClick } = this.props;
    const {
      currentTarget: { value },
    } = e;

    if (value === '') {
      const randomStaff: IBooks.RandomStaff = { id: '' };
      onClick(randomStaff);
      return;
    }

    const staff = staffs.find(s => String(s.id) === value)!;
    onClick(staff);
  }

  public render() {
    const { random, staffs, postable, intl } = this.props;
    return (
      <div>
        {random && (
          // TODO: スタッフ指定しない動作要確認
          <BooksStaffMenu
            staffName={intl.formatMessage({ id: 'books.booksMenu.noSelect' })}
            postable={postable}
            onClick={this.handleChangeStaff}
          />
        )}
        {staffs.map(staff => (
          <BooksStaffMenu
            key={staff.id}
            staffName={staff.name}
            staffImage={staff.image.url}
            staffID={staff.id}
            description={staff.description}
            postable={postable}
            onClick={this.handleChangeStaff}
          />
        ))}
      </div>
    );
  }
}

export default connect()(injectIntl(InputBookingTargetStaffSelector));
